import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { LeaveDto } from './leave-dto.model';


export class LeaveEnCashmentDto implements ILeaveEnCashmentDto {
    id!: number;
    yearMonth!: string | undefined;
    calenderYear!: string | undefined;
    employee!: EmployeeSummaryDto;
    leaveType!: LeaveDto;
    balanceLeave!: number;
    lapseLeave!: number;
    enCashLeave!: number;
    carryForwardLeave!: number;
    remark!: string | undefined;
    fromMonth!: string | undefined;
    toMonth!: string | undefined;
    monthDate!: Date;
    fromMonthDate!: Date;
    toMonthDate!: Date;
    leaveEnCashGross!: number;
    totalDays!: number;
    perDayGross!: number;
    leaveEnCashAmount!: number;

    constructor(data?: ILeaveEnCashmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yearMonth = _data["yearMonth"];
            this.calenderYear = _data["calenderYear"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.leaveType = _data["leaveType"] ? LeaveDto.fromJS(_data["leaveType"]) : <any>undefined;
            this.balanceLeave = _data["balanceLeave"];
            this.lapseLeave = _data["lapseLeave"];
            this.enCashLeave = _data["enCashLeave"];
            this.carryForwardLeave = _data["carryForwardLeave"];
            this.remark = _data["remark"];
            this.fromMonth = _data["fromMonth"];
            this.toMonth = _data["toMonth"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
            this.fromMonthDate = _data["fromMonthDate"] ? new Date(_data["fromMonthDate"].toString()) : <any>undefined;
            this.toMonthDate = _data["toMonthDate"] ? new Date(_data["toMonthDate"].toString()) : <any>undefined;
            this.leaveEnCashGross = _data["leaveEnCashGross"];
            this.totalDays = _data["totalDays"];
            this.perDayGross = _data["perDayGross"];
            this.leaveEnCashAmount = _data["leaveEnCashAmount"];
        }
    }

    static fromJS(data: any): LeaveEnCashmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveEnCashmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yearMonth"] = this.yearMonth;
        data["calenderYear"] = this.calenderYear;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["leaveType"] = this.leaveType ? this.leaveType.toJSON() : <any>undefined;
        data["balanceLeave"] = this.balanceLeave;
        data["lapseLeave"] = this.lapseLeave;
        data["enCashLeave"] = this.enCashLeave;
        data["carryForwardLeave"] = this.carryForwardLeave;
        data["remark"] = this.remark;
        data["fromMonth"] = this.fromMonth;
        data["toMonth"] = this.toMonth;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        data["fromMonthDate"] = this.fromMonthDate ? this.fromMonthDate.toISOString() : <any>undefined;
        data["toMonthDate"] = this.toMonthDate ? this.toMonthDate.toISOString() : <any>undefined;
        data["leaveEnCashGross"] = this.leaveEnCashGross;
        data["totalDays"] = this.totalDays;
        data["perDayGross"] = this.perDayGross;
        data["leaveEnCashAmount"] = this.leaveEnCashAmount;
        return data; 
    }
}

export interface ILeaveEnCashmentDto {
    id: number;
    yearMonth: string | undefined;
    calenderYear: string | undefined;
    employee: EmployeeSummaryDto;
    leaveType: LeaveDto;
    balanceLeave: number;
    lapseLeave: number;
    enCashLeave: number;
    carryForwardLeave: number;
    remark: string | undefined;
    fromMonth: string | undefined;
    toMonth: string | undefined;
    monthDate: Date;
    fromMonthDate: Date;
    toMonthDate: Date;
    leaveEnCashGross: number;
    totalDays: number;
    perDayGross: number;
    leaveEnCashAmount: number;
}

